import { css } from 'lit';

export default css`
  :host {
    display: block;
    user-select: none;
    -webkit-user-select: none;
  }

  :host(:focus) {
    outline: none;
  }

  .option {
    position: relative;
    display: flex;
    align-items: center;
    font-family: var(--webmodule-font-sans);
    font-size: var(--webmodule-font-size-small);
    font-weight: var(--webmodule-font-weight-normal);
    line-height: var(--webmodule-line-height-normal);
    letter-spacing: var(--webmodule-letter-spacing-normal);
    color: var(--webmodule-color-neutral-700);
    padding: var(--webmodule-spacing-x-small) var(--webmodule-spacing-medium) var(--webmodule-spacing-x-small)
      var(--webmodule-spacing-x-small);
    transition: var(--webmodule-animate-fast) fill;
    cursor: pointer;
  }

  .option--hover:not(.option--current):not(.option--disabled) {
    background-color: var(--webmodule-color-neutral-100);
    color: var(--webmodule-color-neutral-1000);
  }

  .option--current,
  .option--current.option--disabled {
    background-color: var(--webmodule-color-primary);
    color: var(--webmodule-color-neutral-0);
    opacity: 1;
  }

  .option--disabled {
    outline: none;
    opacity: 0.5;
    cursor: not-allowed;
  }

  .option__label {
    flex: 1 1 auto;
    display: inline-block;
    line-height: var(--webmodule-line-height-dense);
  }

  .option .option__check {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    visibility: hidden;
    padding-inline-end: var(--webmodule-spacing-2x-small);
  }

  .option--selected .option__check {
    visibility: visible;
  }

  .option__prefix,
  .option__suffix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }

  .option__prefix::slotted(*) {
    margin-inline-end: var(--webmodule-spacing-x-small);
  }

  .option__suffix::slotted(*) {
    margin-inline-start: var(--webmodule-spacing-x-small);
  }
`;
